import React from 'react';
import cn from 'classnames';

import Styles from './index.module.scss';

const RightItem: React.FC = ({children}) => (
    <div className={cn(Styles.container)}>
        {children}
    </div>
)

export default RightItem;
